import { useCallback } from "react"
import { OK } from "utils/constant"
import { setStorage, removeStorage } from "utils/localstorage"
import { handleCaptchaCode } from "utils/verify"
import { filter } from "utils/filter"

const fn = () => { }

export function useSign({
  loading, setLoading, validate, $request, successFn, setHint, remember = false, rememberKey = '', rememberObj = {}, noSignup = fn, resetComponent = () => { }
}) {
  return useCallback(async () => {
    if (loading) return
    if (validate()) {
      setLoading(true)
      try {
        const data = await $request()
        // console.log('datastatyus',data)
        
        if (data.status === OK) {
          if (remember) {
            setStorage(rememberKey, rememberObj)
          } else if (rememberKey) {
            removeStorage(rememberKey)
          }
          window['nvcReset']()
          resetComponent()
          successFn(data)
        } else {
          resetComponent() 
          window['nvcReset']()
          // window['getNC']()
          // console.log('重置阿里云验证')
          const code = data.captcha_code
          if (data.code === 20011) {
            // setHint('请先通过人机验证')
            setHint({ modal: true, text: "请先通过人机验证" })
            handleCaptchaCode(code)
            if (code === "800" || code === "900") {
              setHint({ modal: true, text: "人机验证不通过" })
            }
          } else if (data.code === 20002) {
            setHint({ modal: true, text: data.error })
          } else {
            // rest之前的
            window['nvcReset']()
            if (data.code === 40050) {
              noSignup()
            } else {
              // setHint(filter(data.code, data.error))
              // console.log(filter(data.code, data.error));

              setHint({ modal: true, text: filter(data.code, data.error) })
            }
          }
        }
      } catch (error) {
        // localStorage.setItem("showModal","true")
        window['nvcReset']()
        resetComponent()
        console.log(error)
        // setHint('网络错误')
        setHint({ modal: true, text: "网络错误" })
      }
      setLoading(false)
    }
  }, [loading, setLoading, validate, $request, successFn, setHint, remember, rememberKey, rememberObj, noSignup, resetComponent])
}
